import firebase from 'firebase';
export function uploadFile(directory,file,fileName){

  let storageRef = firebase.storage().ref(directory+'/'+fileName);
  //upload file
  let task = storageRef.put(file);

  return new Promise((resolve, reject) => {
    storageRef.put(file).then(success => {
      resolve(success);

    }).catch(error => {

      reject(error)

    });
    }
  )
}
export function downloadFile(directory,fileName){

  let storageRef = firebase.storage().ref(directory+'/'+fileName);
  //upload file
  return storageRef.getDownloadURL();

}






// WEBPACK FOOTER //
// ./src/API/firebaseStorage.js